import NotificationService, { NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';
import { CookieService } from './cookie-service';

export class DropInRestrictionsService {
  static isResponseUnauthorizedDropInAction(response) {
    if (!response || !response.status) return false;
    return response.status === 403 && DropInRestrictionsService.isDropInActive();
  }

  static isDropInActive() {
    return !!CookieService.getCookieValue('x-imp');
  }

  static getDropinActionRestrictedMessage(response) {
    const defaultMessage =
      "You are not permitted to take this action on a seller's behalf. Contact your team lead if you need this permission.";
    const defaultMessageTitle = 'Restricted Drop-In Action';
    return {
      title: response?.data?.MessageTitle || defaultMessageTitle,
      message: response?.data?.Message || defaultMessage,
    };
  }

  static showDropinActionRestrictedMessage(response, useSystem) {
    const msgObj = DropInRestrictionsService.getDropinActionRestrictedMessage(response);
    if (useSystem) {
      alert(msgObj.message);
      return;
    }

    // No need to internationalize this...
    NotificationService.showNotification({
      notificationType: NOTIFICATION_TYPE_ERROR,
      title: msgObj.title,
      content: msgObj.message,
      duration: undefined,
    });
  }
}
